const API = process.env.REACT_APP_API_URL ?? 'http://localhost:5000/api';

async function send(url, options) {
    const res = await fetch(url, {
        headers: {'Content-Type': 'application/json'},
        ...options,
    });

    if (!res.ok) {
        const body = await res.json().catch(() => null);
        throw new Error(body?.error ?? `Erreur ${res.status}`);
    }

    return res.status === 204 ? null : res.json();
}

export const getNotes = (tag) => send(`${API}/notes${tag ? `?tag=${encodeURIComponent(tag)}` : ''}`);
export const getTags = () => send(`${API}/tags`);
export const createNote = (note) => send(`${API}/notes`, {method: 'POST', body: JSON.stringify(note)});
export const updateNote = (id, note) => send(`${API}/notes/${id}`, {method: 'PUT', body: JSON.stringify(note)});
export const deleteNote = (id) => send(`${API}/notes/${id}`, {method: 'DELETE'});
